export default {
  //----- GENERAL -----------------------------------------------------------------------

  PRODUCTION: false,
  API: "/api/",
  // API: "http://inventory.duke.local/",
  API_FUNCTIONS: "functions.php",

  //----- UTILITIES ------------------------------------------------------------------

  getTrimmedId(completeId, lenght) {
    if (!completeId) return "";
    return completeId.substring(0, lenght);
  },
  getTrimmedId12(completeId) {
    if (!completeId) return "";
    return completeId.substring(0, 12);
  },
  isInt: function (value) {
    return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
  },
};
